import React, {Component} from 'react';
import "./UserChat.css";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../configuration";
import GoogleAds from "../../Common/GoogleAds/GoogleAds";

class UserChat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            intervalId: -1,
            chatMessage: "",
            chats: []
        };

        this.sendChat = this.sendChat.bind(this);
        this.getUpdate = this.getUpdate.bind(this);
        this.setChatMessage = this.setChatMessage.bind(this);
    }

    componentDidMount() {
        let intervalId = setInterval(this.getUpdate, 2000);
        this.setState({intervalId: intervalId});
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.bottomFix.scrollIntoView({behavior:"smooth"});
    }

    getUpdate = () => {
        // console.log("Fetching...");

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/chat', axiosConfig)
            .then((res) => {
                this.setState({
                    chats: res.data
                });
                // console.log("Fetched:", res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    setChatMessage = (e) => {
        this.setState({chatMessage: e.target.value});
    };

    sendChat = () => {
        // console.log(this.state.chatMessage);
        if (this.state.chatMessage === "") return;

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        let chat = {
            message: this.state.chatMessage,
            createdBy: "1"
        };
        axios.post(RESOURCE_BASE_URL + 'api/chat', chat, axiosConfig)
            .then((res) => {
                // console.log("DATA",res.data);
                this.setState({
                    chatMessage: ""
                });
                this.chatBox.value= "";
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    render() {
        let fullwidth = {width: "100%"};
        // console.log(this.state.chatMessage)
        return (
            <div className="chat-container">
                <GoogleAds slot="696274611" />
                <div className="chat-top">
                    {this.state.chats.map((c) => {
                        let className = (c.createdBy === "1") ?
                            "chat-message chat-user-1" : "chat-message chat-user-2";
                        return (
                            <div className={className}>
                                {c.message}
                            </div>
                        )
                    })}
                    <div className="bottom-fix" ref={(el) => {
                        this.bottomFix = el;
                    }}> </div>
                </div>
                <div className="chat-bottom">
                    <div><textarea onChange={this.setChatMessage} style={fullwidth} rows={5}
                                   ref={(el) => {this.chatBox = el;}}>
                        {this.state.chatMessage}
                    </textarea></div>
                    <div><button onClick={this.sendChat} className="btn btn-primary send-button">Send</button></div>
                </div>
            </div>
        )
    }
}

export default UserChat;



// WEBPACK FOOTER //
// ./src/components/Site/UserChat/UserChat.js